import React, { useEffect, useState } from 'react';
import './index.scss';
import { Typography, Tabs, notification, Card, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import API_SERVICE from 'shared/services/api-service';
import ProductCardGrid from '../../components/ProductCardGrid/ProductCardGrid';
import Paragraph from 'antd/es/typography/Paragraph';
import { useHistory } from 'react-router-dom';

const { TabPane } = Tabs;

const { Title } = Typography;
export default function CategoriesCoursesSection() {
    const { t } = useTranslation();
    const history = useHistory();
    const [categories, setCategories] = useState([] as any[]);
    useEffect(() => {
        API_SERVICE.fetchCategories({ per_page: 4 }).then(({ data: { data: { items } } }) => {
            setCategories(items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        });
    }, []);
    // const settings = JSON.parse(localStorage.getItem('settings') as string);

    // let featuredText = t('home.coursesByTopCategories');
    // let featuredText2 = t('home.coursesByTopCategoriesDescription');
    // if (settings && settings.theme_config) {
    //     featuredText = JSON.parse(settings.theme_config).homeTitle || featuredText;
    //     featuredText2 = JSON.parse(settings.theme_config).homeDescription || featuredText2;
    // }
    return (
        <div className={'categories-courses-section mb-0'}>
            <div className="container-fluid home-top-course pt-4 pb-4">
                <div className="plr-4rem">
                    <h4>Top Course</h4>
                    <p className="mb-2">Find the right course for you!!!</p>
                    <div className='tabs-wrapper home-cat-course'>
                        <Tabs defaultActiveKey='1'>
                            {categories.map((category: any) => {
                                return <TabPane tab={category.name} key={category.id}>
                                    <div className=''>
                                    <Card className="bg-transparent br-0px">
                                        {/* <Paragraph>
                                            <div dangerouslySetInnerHTML={{ __html: category.description }} />
                                        </Paragraph> */}

                                        <ProductCardGrid numberOfCourses={4} selectedCategory={category.id} />
                                        <div className='text-center'>
                                            <Button className='btn btn-blue' onClick={() => {
                                                history.push(`/courses?categoryId=${category.id}`);
                                            }
                                            }>{t('genDict.explore')} {category.name}</Button>
                                        </div>
                                    </Card>
                                    </div>
                                </TabPane>;
                            })}
                        </Tabs>
                    </div>
                </div>
            </div>
            {/* <Title level={3}>{featuredText}</Title>
            <Title level={5}>{featuredText2}</Title> */}
        </div>
    );
}
